import * as Yup from 'yup'

export default Yup.object().shape({
  bsb: Yup.string().required('BSB is required'),
  accountNumber: Yup.string().required('Account Number is required'),
})
